export default "/fonts/vendor/katex/dist/KaTeX_Script-Regular.ttf?fc9ba5249878cd8f8d885c1f42b0f43d";